const translation = {
  phone: "+99890-123-12-23",
  Navigation: {
    Phone: "Phone",
    Email: "Email us",
    Quote: "BOOK NOW",
    Home: "Home",
    Services: "Services",
    Why: "Why Hire Us",
    Who: "Who We Are",
    Contact: "Contact Us",
    QuoteLast: "BOOK NOW",
  },
  AboutArea: {
    aboutOurCompany: "About our Company",
    aboutOurCompanySubText: `MANINO CLEANING AND MOVING SERVICE`,
    HassleFree: "Hassle free cleaning and moving service for busy individuals",
    FreeConsultacy: "Free Consultacy",
    Mission: "Our Misson",
    MissionText: `To create a clean environment for individuals!
       We provide the most reliable and quality service. Our hassle
        free online booking system and call center is at your service`,
    MoreInfo: "Book Now",
    Residential: "Residential Cleaning Services",
    ResidentialText: `If you are individual with little time for house cleaning,
      Manino service team can help you. Have you considered to get
      recurring cleaning services for your home? You may be surprised
      by the benefits. Our affordable, customized cleaning plans that
      fit your cleaning needs and schedule so you can spend more time
      with family and friends. Give your family a fresher and
      healthier environment.`,
    General: "General Cleaning",
    Deep: "Deep Cleaning",
    MoveCleaning: "Move in and Move out Cleaning",
    CommercialCleaning: "Commercial Cleaning ",
    CommercialCleaningText: `If you run a business, keeping it clean is important to maintain a healthy work environment, which benefits employees and can help your business attract new clients and customers. Manino makes commercial cleaning convenient for business owners and facility managers. Manino commercial cleaning services help create a healthier indoor environment for employees and visitors.`,
  },
  PopularServices: {
    subtitle: "Our Popular Services",
    title: "Our Popular Services",
    serviceItemOne: "Commercial cleaning services ",
    serviceItemTwo: "Residential cleaning services ",
    serviceItemThere: "Recurring cleaning services ",
    serviceItemFour: "One Time Cleaning ",
    serviceItemFive: "Move In Cleaning ",
    serviceItemSix: "Move out cleaning ",
    serviceItemOneInfo:
      "Manino professional commercial cleaning services frees up time for you to focus on other important things—like running a business or organization. ",
    serviceItemTwoInfo:
      "Our customized house cleaning services are here to make your life easier and your home a cleaner and more healthful place to live. ",
    serviceItemThereInfo:
      "We all need service we can rely on. These weekly, biweekly, or monthly cleaning services offer several benefits to maintain your quality of life and increase the joy of walking through the front door to a clean home! ",
    serviceItemFourInfo:
      "You can count on Manino house cleaning that refreshes your home and makes it easier to maintain. That way, you can spend less time cleaning and more time enjoying the things you love",
    serviceItemFiveInfo:
      "The best time to clean your new home is while it's empty. Our move-in cleaning service is customized for your needs and budget, so you pick what you need. ",
    serviceItemSixInfo:
      "Leaving your former residence in great shape will be much easier to achieve with Manino team. We’ll handle the cleanup while you set up your new place just the way you want it. ",
  },
  ChoseArea: {
    WhyHireUs: "Why Hire Us",
    ExpertHouse: "Expert House Cleaning Service Can Trust",
    EveryCustomer: `Every Customer
        is Special`,
    EveryCustomerText: `Every customer is uniqure. We treat every customers individually. No job is too big or small for Manino`,
    Quality: "Quality",
    QualityText: `There’s no better feeling than coming home to a freshly cleaned home.
        When Manino performs a service, people notice. We want you to feel proud
        of your home and confident in our ability to accommodate all your cleaning needs.
          quam`,
    satisfaction: "Your satisfaction matters in Fees",
    setisfactionText: `We are proud of providing worry free service.Our customers love what we do.
        Each member of our team undergoes extensive vetting and a thorough training process
        upon hiring and is fully insured for your protection.
          quam`,
    BookAppointment: "Book Appointment online",
    BookAppointmentText: `Our highly interactive website enables you to schedule your next cleaning service online 
          quam`,
    Trust: "Trust",
    TrustText: `Our customers love that they can trust us to truly care for their homes.
          When you request Manio housekeeper servies, you can always expect us to
          maintain an open line of communication, pay close attention to every, datail,
          and show our commitment to your complete setifaction
          quam`,
    WorryFree: "Worry-Free",
    WorryFreeText: `We are proud of providing worry free service. Our customers
          love what we do. Each member of our team undergoes extensive
          vetting and a thorough training process upon hiring and is fully insured for your protection. 
          quam`,
  },
  Footer: {
    OurServices: "Our Services",
    Carpet: "Carpet Cleaning",
    Plumbing: "Plumbing Serivices",
    ParkClear: "Park Cleaning",
    Residential: "Residential Services",
    Copyright: "Copyright ©",
    AllRightsReserved: "All Rights Reserved",
    Apps: "EZ Apps",
  },
  Blogs: {
    SomeRecent: "Some Recent Articls",
    Work: "Work Together to Create Something Greater",
  },
  CtaArea: {
    Online: "Online Appointment",
    Service: "Service Name",
    Commercial: "Commercial Service",
    Residential: "Residential Service",
    Industrial: "Industrial Service",
    CommercialLast: "Commercial Service",
    ResidentialLast: "Residential Service",
    Submit: "Submit now",
  },
  PricingArea: {
    Affordable: "Our Affordable Package",
  },
  Special: "Special Pricing PackageNo Hidden Charge",
  ProgressArea: {
    OurWork: "Our work Experience",
    FindStandart: "Find Standard Cleaning with Personal Touch",
    DuisText: `Duis nunc sodales conubia aid laoreet aliquet nostra
      eleifend lacinias prasent hendrerit quisque penatibus erat. At pulvinar
      integer semper ridiculus lectuse condimentum obor tise verodar capmtaso morin
      proin nibh posuere.`,
    Repair: "Repair Quality",
    Happy: "Happy Customer",
    Support: "Support Centre",
    SomeCompleted: "Some Completed Project",
    EveryProject: "Every Project is Different Every Client special",
  },
  ServiceArea: {
    OurPopular: "Our Popular Services",
    OurSuccess: "Our Success Cleaning Up your Mess",
  },
  Testimonial: {
    CustomerStatement: "Customer Statement",
    OurClient: "Our Client Feedback",
    Prev: "Prev",
    Next: "Next",
  },
  AboutSinglePrice: {
    CarpetCleaning: "Carpet Cleaning",
    Bathroom: "Bathroom Cleaning",
    Floor: "Floor Cleaning",
    Bedroom: "Bedroom Cleaning",
    Get: "Get Service",
  },
  AboutSingleTestimonial: {
    Erat: `Erat dapibus interdum consequat eleifend. Porttitor iaculis per lectus ornare dolor pede.
     Metus urna faucibus montes duis conds imentum congue. Accumsan bibendum pharetra a quisque nulla dictumst quam praesent
     pharetra cos aptent sociosqu. Imperdiet mattis sociosqu differ frome aliquam.`,
  },
  AppointmentSingleFeadback: {
    Hymenaeos: `Hymenaeos rhoncus proin aliquam justo sum mauris rutrum nulam semper purus rutru non sociis
        libero varius cumer to duine felis enisa porta ridiculus nisl acequis.`,
  },
  Breadcrumb: {
    Home: "Home",
  },
  FaqSingleItem: {
    Edite: `Edite per sociosqu felis quam ridiculus laoreet tempus, eleifend faucibus commodo.
        Laoreet mauris congue sodales interdum lobortis proin laoreet quis arcu nostra et nam primis dolor
        sagittis duis laoreet, ultrices habitasse diam quisque in auctor porta metus viverra curae maecenas
        iaculis tempo pulvinar vitae dictum lorem ipsum orci.`,
  },
  HomeHeroSingleSlide: {
    TakeBack: "Take your free time back!",
    Orderyour: "Order your",
    moving: "cleaning",
    service: "service",
    LearnMore: "BOOK NOW ",
  },
  HomeHeroSingleSlide2: {
    TakeBack: "Take your free time back!",
    Orderyour: "Order your",
    moving: "moving",
    service: "service",
    LearnMore: "BOOK NOW ",
  },
  HeroSection: {
    subtitle: "Premium Home Services",
    title: "Cleaning, Moving & Outsource Support Made Easy",
    description:
      "Free up your schedule with a tailored team that keeps your home sparkling, your move stress-free, and your to-do list under control.",
    primaryCta: "Book Now",
    secondaryCta: "Watch Video",
    cards: {
      cleaning: {
        title: "Cleaning",
        description:
          "Detailed housekeeping for apartments, homes, and offices with eco-friendly products and vetted specialists.",
        cta: "Schedule Cleaning",
      },
      moving: {
        title: "Moving",
        description:
          "Full-service support for packing, transport, and setup so every relocation feels organized and calm.",
        cta: "Plan Your Move",
      },
      outsource: {
        title: "Outsource",
        description:
          "Flexible staffing for reception, maintenance, and daily assistance whenever your team needs an extra hand.",
        cta: "Request Support",
      },
    },
  },
  HomeServiceItem: {
    Bras: `Bras fringilla conubia odios uira metus torquent commodo quam
        praesent torna pede`,
    GetQuote: "Get Quote",
  },
  HomeSingleBlog: {
    HomeCleaning: "Home Cleaning",
    Continue: "Continue Reading",
  },
  HomeSinglePrice: {
    Carpet: "Carpet Cleaning",
    Bathroom: "Bathroom Cleaning",
    Floor: "Floor Cleaning",
    Bedroom: "Bedroom Cleaning",
  },
  HomeSingleProject: {
    Residential: "Residential Service",
  },
  HomeSingleTestimonial: {
    EratText: `Erat dapibus interdum consequat eleifend. Porttitor iaculis per lectus ornare dolor pede.
         Metus urna faucibus montes duis conds imentum congue. Accumsan bibendum pharetra a quisque nulla dictumst
          quam praesent pharetra cos aptent sociosqu. Imperdiet mattis sociosqu differ frome aliquam.`,
  },
  HomeThreeHeroSlide: {
    Fast: "Fast and efficient service",
    Cleaning: `Cleaning
        Excellence
        Guaranteed!`,
    LearnMore: "Learn More",
  },
  HomeThreeSIngleAbout: {
    Duis: `Duis congue atend lorem consequat interdum pretium ligula sempe`,
    ByJhon: "By Jhon Cardo",
    Jun: "Jun 02 - 2021",
    Continue: "Continue Reading",
  },
  HomeThreeSingleChoseArea: {
    FacilsisText: `Facilsis veicula hendrerit turp turpis solutat neique dapibus justo rdiculu dapibus no ridiculuy`,
  },
  HomeThreeSingleFeature: {
    Coingue:
      "Coingue aten lorem consqua interdum pretium ligaula a semper mauris easy dictuma",
  },
  HomeTwoCtaSingleItem: {
    Coingue:
      "Coingue atend lorem consequas interdum pretium ligula semper mauris is dictuma",
  },
  HomeTwoHeroSectionSingleSlide: {
    GetProfessional: "Get Professional",
    CleaningServices: "Cleaning Services",
    CleanUp: "Clean up and see the change",
  },
  HomeTwoSingleFeature: {
    Duis: "Duis congue atend lorem consequat interdum pretium ligula",
  },
  ServicePageArea: {
    Buscipit: `Buscipit tincidunt duis antino gravidia nam tellusy
        nascetur neque vulpuits aenean is scelerisque ultrces muscle mass and matter order commo`,
    LearnMore: "Learn More",
  },
  ServiceTestimonial: {
    Hymenaeos: `Hymenaeos rhoncus proin aliquam justo sum mauris rutrum nulam semper purus rutru non sociis
        libero varius cumer to duine felis enisa porta ridiculus nisl acequis.`,
  },
  TeamSIngleBlog: {
    Aug: "Aug",
    Residential: "Residential",
    Fementum: "Fementum pede commodo sceid gone malesua",
    Details: "Details Here",
  },
  Sidebar: {
    Home: "Home",
    Services: "Services",
    WhyHire: "Why Hire Us",
    WhoWe: "Who We Are",
    ContactUs: "Contact Us",
  },
  SingleAppointmentFeature: {
    Coingue:
      "Coingue aten lorem consqua interdum pretium ligaula a semper mauris easy dictuma",
  },
  SpecialSinglePricingPackage: {
    Carpet: "Carpet Cleaning",
    Bathroom: "Bathroom Cleaning",
    Floor: "Floor Cleaning",
    Bedroom: "Bedroom Cleaning",
  },
  Quote: {
    GetYour: "Book Now",
    Form: "Form",
    select: "Select",
    numberOfRooms: "Number of rooms",
    numberOfRoomsPh: "Enter number of rooms",
    fullName: "Full name",
    fullNamePh: "Enter your full name",
    address: "Address",
    addressPh: "Enter your address",
    phone: "Phone",
    submit: "Submit",
    district: {
      label: "Select your Tashkent district",
      placeholder: "Select your Tashkent district",
      items: {
        bektemir: "Bektemir",
        chilonzor: "Chilonzor",
        yashnobod: "Yashnobod",
        mirobod: "Mirobod",
        mirzoUlugbek: "Mirzo Ulug'bek",
        olmazor: "Olmazor",
        sergeli: "Sergeli",
        shayxontohur: "Shayxontohur",
        uchtepa: "Uchtepa",
        yakkasaroy: "Yakkasaroy",
        yangihayot: "Yangihayot",
      },
    },
    InputTitle: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      next: "Next",
      back: "Back",
      address: "Address",
      state: "Satate",
      city: "City",
      zipCode: "Zip code",
      suit: "Apt/suit",
    },
    FormTitle: {
      ServicesPosition: "Select your service type",
      ServicesType: "Select your service type",
      ServicesPlan: "Select your service type",
      Premises: "How big is your premises?",
      AdditionalServices: "Additional services",
      Time: "Select the time slot suitable for you",
      ClientInfo: "About you",
      Salary: "Your Clean Premises Plan",
      Location: "Loacation",
      Recomendation:
        "First cleaning is always deep cleaning. 20% discount applies starting the second visit if you pick one of our weekly or monthly plans.",
    },
    ServicesPosition: {
      residential: {
        generial: "General Cleaning",
        deep: "Deep Cleaning ",
        movie: "Move in and Move out Cleaning ",
        postConstruction: "Post Construction Cleaning",
      },
      commercial: {
        generial: "General Cleaning ",
        deep: "Deep Cleaning",
        movie: "Move in and Move out Cleaning",
      },
      postConstruction: {
        residential: "Residential Moving",
        commercial: "Commercial Moving",
      },
      moving: {
        residential: "Residential",
        commercial: "Commercial",
      },
    },
    ServicesType: {
      residential: "Residential Cleaning",
      commercial: "Commercial Cleaning",
      moving: "Moving",
    },
    ServicesPlan: {
      week2: "2 x times in a week",
      week1: "1 x time in a week",
      month2: "2 x times in a month",
      month1: "1 x time in a month",
      cleaningOne: "On time cleaning service",
    },
    AdditionalServices: {
      insideFridge: "Inside fridge",
      insideOven: "Inside oven",
      interiorWindows: "Clean interior windows",
      dishwashing: "Dishwashing (hour)",
      furniture: "Dry cleaning of upholstered furniture (hour)",
      carpet: "Carpet dry cleaning (hour)",
    },
    Premises: {
      insideFridge: "Number of refrigerators",
      insideOven: "Number of gas stoves",
      interiorWindows: "Inner window surface",
      dishwashing: "How long (in hours)",
      furniture: "How long (in hours)",
      carpet: "How long (in hours)",
    },
    Salary: {
      subtitle: "Don’t worry – you can change it or cancel at any time",
      surfaceTitle: "Total surface",
      salaryTitle: "First cleaning total",
      salarySubtitle:
        "If you subscribe to the continuous cleaning service, you will receive a 20% discount from the second cleaning.",
      servicesTitle: "Services type",
      size: "or",
      price: "Price",
      test: "Size",
      time: "Time",
    },
    endPage: {
      title: "Thank you for trusting us!",
      subtitle: "We are happy to serve you!",
      resTitle:
        "Congratulations, you have activated your order, you will be contacted soon!",
      btnToHome: "Home",
      btn: "Submit",
    },
  },
};

export default translation;
